import { useLocalStorage, useReadLocalStorage } from "usehooks-ts";

const darkModeKey = "cc-circle-dark-mode";
export const useCircleDarkMode = () =>
  useReadLocalStorage<boolean>(darkModeKey);

export const useCircleDarkModeReadWrite = () =>
  useLocalStorage(darkModeKey, false);
